import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { TraitementDataFuitesComponent } from '../../traitement-data/traitement-data-fuites/traitement-data-fuites.component';
import { TraitementDataIahrComponent } from '../../traitement-data/traitement-data-iahr/traitement-data-iahr.component';
import { TraitementDataModeComponent } from '../../traitement-data/traitement-data-mode/traitement-data-mode.component';
import { TraitementDataObsComponent } from '../../traitement-data/traitement-data-obs/traitement-data-obs.component';
import { TraitementDataP9095Component } from '../../traitement-data/traitement-data-p90-95/traitement-data-p90-95.component';
import { TraitementDataPressionFixeComponent } from '../../traitement-data/traitement-data-pression-fixe/traitement-data-pression-fixe.component';
import { TraitementDataTypeDeMasqueComponent } from '../../traitement-data/traitement-data-type-de-masque/traitement-data-type-de-masque.component';
import { TraitementDataComponent } from '../../traitement-data/traitement-data/traitement-data.component';
import { TraitementDataPressionAutoComponent } from "../../traitement-data/traitement-data-pression-auto/traitement-data-pression-auto.component";
import { TraitementDataO2EffortComponent } from '../../traitement-data/traitement-data-o2-effort/traitement-data-o2-effort.component';
import { TraitementDataO2ReposComponent } from '../../traitement-data/traitement-data-o2-repos/traitement-data-o2-repos.component';
import { TraitementDataDureeComponent } from '../../traitement-data/traitement-data-duree/traitement-data-duree.component';

@Component({
  selector: 'app-traitement-ppc-card',
  standalone: true,
  imports: [
    TraitementDataObsComponent,
    TraitementDataIahrComponent,
    TraitementDataFuitesComponent,
    TraitementDataP9095Component,
    TraitementDataModeComponent,
    TraitementDataPressionFixeComponent,
    TraitementDataTypeDeMasqueComponent,
    TraitementDataComponent,
    TraitementDataPressionAutoComponent,
    TraitementDataO2EffortComponent,
    TraitementDataO2ReposComponent,
    TraitementDataDureeComponent,
  ],
  templateUrl: './traitement-ppc-card.component.html',
  styleUrl: './traitement-ppc-card.component.scss',
})
export class TraitementPpcCardComponent {
  @Input() patient: Patient | undefined;
  @Input() activite: String | undefined;
}
